export const authContrCols = [
  {
    name: 'corresponding_author',
    field: 'corresponding_author',
    align: 'center',
    label: 'Author'
  },
  {
    name: 'articles_count',
    field: 'articles_count',
    align: 'center',
    label: 'Articles'
  }
]

export const publContrCols = [
  {
    name: 'publisher_name',
    field: 'publisher_name',
    align: 'center',
    label: 'Publisher'
  },
  {
    name: 'articles_count',
    field: 'articles_count',
    align: 'center',
    label: 'Articles'
  }
]

export const journContrCols = [
  {
    name: 'journal_name',
    field: 'journal_name',
    align: 'center',
    label: 'Journal'
  },
  {
    name: 'print_identifier',
    field: 'print_identifier',
    align: 'center',
    label: 'ISSN'
  },
  {
    name: 'online_identifier',
    field: 'online_identifier',
    align: 'center',
    label: 'eISSN'
  },
  {
    name: 'articles_count',
    field: 'articles_count',
    align: 'center',
    label: 'Articles'
  }
]

export const subAreasContrCols = [
  {
    name: 'name',
    field: 'name',
    align: 'center',
    label: 'Subject'
  },
  {
    name: 'code',
    field: 'code',
    align: 'center',
    label: 'Code'
  },
  {
    name: 'articles_count',
    field: 'articles_count',
    align: 'center',
    label: 'Articles'
  }
]
